import jwtAuthAxios from "./auth/jwtAuth";

const dashboardServices = {};

dashboardServices.getStockByShip = async () => {
    try {
      const { data } = await jwtAuthAxios.get('/dashboard/get_stock_by_ship');
      return data;
    } catch (error) {
      console.error('Error fetching stock by ship data:', error);
      throw error;
    }
};

dashboardServices.getDeliveriesByDate = async (filters) => {
  try {
      const { naviera, embarcacion, cliente, desde, hasta } = filters;

      const queryParams = new URLSearchParams({
          naviera: naviera || '',
          embarcacion: embarcacion || '',
          cliente: cliente || '',
          desde: desde || '',
          hasta: hasta || ''
      }).toString();

      const { data } = await jwtAuthAxios.get(`/dashboard/get_deliveries_by_date?${queryParams}`);
      return data;
  } catch (error) {
      console.error('Error fetching deliveries by date:', error);
      throw error;
  }
};

dashboardServices.getDeliveriesByCustomer = async (filters) => {
  try {
    const { cliente, naviera, embarcacion, desde, hasta } = filters;

    // Construir la URL con los filtros aplicados
    const params = {};

    if (cliente && cliente.length > 0) params.cliente = cliente.join(',');
    if (naviera && naviera.length > 0) params.naviera = naviera.join(',');
    if (embarcacion && embarcacion.length > 0) params.embarcacion = embarcacion.join(',');
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;

    const queryParams = new URLSearchParams(params).toString();

    const { data } = await jwtAuthAxios.get(`/dashboard/get_deliveries_by_customer?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching deliveries by customer:', error);
    throw error;
  }
};

dashboardServices.getMonthlyFuelDeliveries = async (filters) => {
  try {
    const params = {};
    if (filters.naviera && filters.naviera.length > 0) params.naviera = filters.naviera.join(',');
    if (filters.embarcacion && filters.embarcacion.length > 0) params.embarcacion = filters.embarcacion.join(',');
    if (filters.cliente && filters.cliente.length > 0) params.cliente = filters.cliente.join(',');

    const queryParams = new URLSearchParams(params).toString();

    const { data } = await jwtAuthAxios.get(`/dashboard/get_monthly_fuel_deliveries?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching monthly fuel deliveries:', error);
    throw error;
  }
};

dashboardServices.getOrderPickingStats = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;
    if (filters?.group_by) params.group_by = filters.group_by;
    if (filters?.top) params.top = filters.top;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_order_picking_stats?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching order picking stats:', error);
    throw error;
  }
};

dashboardServices.getPickerPickingDetails = async (filters) => {
  try {
    const params = {};
    if (filters?.user_id) params.user_id = filters.user_id;
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_picker_picking_details?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching picker picking details:', error);
    throw error;
  }
};

dashboardServices.getDriverOrderBreakdown = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;
    if (filters && Object.prototype.hasOwnProperty.call(filters, "driver_ids")) {
      const driverIds = Array.isArray(filters.driver_ids) ? filters.driver_ids : [];
      params.driver_ids = driverIds.join(',');
    }

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_driver_order_breakdown?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching driver order breakdown:', error);
    throw error;
  }
};

dashboardServices.downloadDriverOrderBreakdownXlsx = async (filters) => {
  try {
    const params = {};
    params.format = 'xlsx';
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;
    if (filters && Object.prototype.hasOwnProperty.call(filters, "driver_ids")) {
      const driverIds = Array.isArray(filters.driver_ids) ? filters.driver_ids : [];
      params.driver_ids = driverIds.join(',');
    }

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_driver_order_breakdown.xlsx?${queryParams}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
    return data;
  } catch (error) {
    console.error('Error downloading driver order breakdown xlsx:', error);
    throw error;
  }
};

dashboardServices.getOrderCompletionTrend = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;
    if (filters?.group_by) params.group_by = filters.group_by;
    if (filters?.top) params.top = filters.top;
    if (Object.prototype.hasOwnProperty.call(filters ?? {}, 'driver_ids')) {
      const driverIds = Array.isArray(filters.driver_ids) ? filters.driver_ids : [];
      params.driver_ids = driverIds.join(',');
    }

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_order_completion_trend?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching order completion trend:', error);
    throw error;
  }
};

dashboardServices.getDriverCompletionDetails = async (filters) => {
  try {
    const params = {};
    if (filters?.driver_id) params.driver_id = filters.driver_id;
    if (Array.isArray(filters?.driver_ids) && filters.driver_ids.length > 0) params.driver_ids = filters.driver_ids.join(",");
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_driver_completion_details?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching driver completion details:', error);
    throw error;
  }
};

dashboardServices.getRouteCompliance = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;
    if (filters?.driver_id) params.driver_id = filters.driver_id;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_route_compliance?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching route compliance:', error);
    throw error;
  }
};

dashboardServices.getWorkdayOverflow = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_workday_overflow?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching workday overflow:', error);
    throw error;
  }
};

dashboardServices.getProblemBreakdown = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_problem_breakdown?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching problem breakdown:', error);
    throw error;
  }
};

dashboardServices.getPreparationFunnel = async (filters) => {
  try {
    const params = {};
    if (filters?.desde) params.desde = filters.desde;
    if (filters?.hasta) params.hasta = filters.hasta;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_preparation_funnel?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching preparation funnel:', error);
    throw error;
  }
};

dashboardServices.getActiveRoutes = async (filters) => {
  try {
    const params = {};
    if (filters?.fecha) params.fecha = filters.fecha;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_active_routes?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching active routes:', error);
    throw error;
  }
};

// Panel de la tarjeta "Entregadas": el avance del dia, viaje por viaje.
dashboardServices.getDeliveryProgress = async (filters) => {
  try {
    const params = {};
    if (filters?.fecha) params.fecha = filters.fecha;

    const queryParams = new URLSearchParams(params).toString();
    const { data } = await jwtAuthAxios.get(`/dashboard/get_delivery_progress?${queryParams}`);
    return data;
  } catch (error) {
    console.error('Error fetching delivery progress:', error);
    throw error;
  }
};

dashboardServices.getSubscriptionOrderUsage = async () => {
  try {
    const { data } = await jwtAuthAxios.get('/dashboard/get_subscription_order_usage');
    return data;
  } catch (error) {
    console.error('Error fetching subscription order usage:', error);
    throw error;
  }
};


  
export default dashboardServices;
